export const TestError = () => {
  throw new Error(
    `Error successful! - ${import.meta.env.VITE_SENTRY_DSN} ${
      import.meta.env.VITE_ENVIRONMENT
    }`
  );
};
